
import axios from 'axios'
import { getToken, removeToken } from 'minerva-ui-sdk'

function errorParser (response) {
  if (response.status === 200 || response.status === 204) {
    return response
  } else if (response.status === 403) {
    // TODO: use Ant Design notification
    // notification.error({ message: 'Forbidden', description: response.data.message })
    return Promise.reject(new Error('禁止访问'))
  }
  if (response.status === 401) {
    const token = getToken()
    //   TODO: use Ant Design notification
    //   notification.error({
    //     message: '身份认证错误',
    //     description: '身份认证已失效，即将返回登录'
    //   })
    if (token) {
      removeToken()
      setTimeout(() => {
        window.location.reload()
      }, 1500)
      // store.dispatch('Logout').then(() => {
      // })
    }
    return Promise.reject(new Error('未获得登录授权'))
  } else if (response.data && response.data.error) {
    const error = new Error(response.data.error.message)
    return Promise.reject(error)
  }
  return Promise.reject(new Error('未知的请求错误'))
}

export const createInstance = (baseUrl, authenticated) => {
  let headers = {}
  if (authenticated) { headers = { 'x-auth-key': 'Bearer ' + getToken() } }
  const instance = axios.create({
    baseURL: baseUrl,
    headers,
    validateStatus: () => true
  })
  instance.interceptors.response.use(errorParser)
  return instance
}

export const createAuthInstance = (baseUrl) => createInstance(baseUrl, true)
